module.exports = __webpack_public_path__ + "static/media/Italian_traffic_signs_Sgombraneve_in_Azione-CL.402f3e38.svg";